import axios from 'axios';

export default axios.create({
  baseURL: 'https://api.tizeti.com/api/v1',
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem('token')}`,
  },
});
